import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import { SALE_MOVIE_PAGE } from "../../../app/routes";
// import { useSelector } from "react-redux";
// import { State } from "../../../app/store";
//
// const imageColor = "var(--primary-color)";

const DesktopNavBar: React.FC = () => {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  // const basketLength = useSelector((state: State) => state.basket.basketLength);
  // const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);
  return (
    <div className="navbar">
      <div className="navbar-logo" onClick={() => navigate(SALE_MOVIE_PAGE)}>
        <img src="https://panel.eaktywni.pl/img/1222/ciezkowice_logo23.jpg" alt={"logo"} />
      </div>
      <div className="navbar-links">
        <Link className={active === 0 ? "active" : ""} to={SALE_MOVIE_PAGE} onClick={() => setActive(0)}>
          Repertuar
        </Link>
        {/*<Link className={active === 1 ? "active" : ""} to={SALE_FOOD_PAGE} onClick={() => setActive(1)}>*/}
        {/*  Bar*/}
        {/*</Link>*/}
        {/*<Link className={active === 2 ? "active" : ""} to={NEWS_PAGE} onClick={() => setActive(2)}>*/}
        {/*  Wydarzenia*/}
        {/*</Link>*/}
        {/*<Link className={active === 3 ? "active" : ""} to={LOGIN_PAGE} onClick={() => setActive(3)}>*/}
        {/*  Konto*/}
        {/*</Link>*/}
        {/* <Link to={FINALIZE_PAGE}>
          <Badge badgeContent={basketLength} color="primary" style={{ marginTop: 10 }}>
            <CartOutline color={imageColor} title={"Koszyk"} height="30px" width="30px" />
          </Badge>
        </Link> */}
      </div>
    </div>
  );
};

export default DesktopNavBar;
